<template>
	<v-col>
		<base-material-card>
			<template #heading>
				<div
					:class="
						$vuetify.breakpoint.smAndDown
							? 'text-center display-2 font-weight-light'
							: 'display-2 font-weight-light'
					"
				>
					ניהול מנויים
				</div>
			</template>
			<v-card>
				<v-card-title>
					<v-row>
						<v-col cols="8">
							<v-text-field
								v-model="lookingFor"
								append-icon="mdi-magnify"
								label="חיפוש"
								single-line
								hide-details
							/>
						</v-col>
						<v-col cols="4">
							<v-btn color="success" @click="downloadExcel">
								<v-icon>mdi-microsoft-excel</v-icon>
								<span v-if="$vuetify.breakpoint.mdAndUp" class="mr-2"
								>הורדת דו"ח</span
								>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-title>
				<v-data-table
					:headers="headers"
					:items="subscriptions"
					:loading="loading"
					class="elevation-1"
					:search="lookingFor"
				>
					<v-progress-linear slot="progress" color="blue" indeterminate />
				</v-data-table>
			</v-card>
		</base-material-card>
	</v-col>
</template>

<script>
import { types as subscriptionTypes } from "src/store/modules/Subscription.module";

export default {
	name: "ProjectSubscriptions",
	components: {},
	data() {
		return {
			loading: false,
			headers: [
				{
					text: "שם",
					value: "user.name"
				},
				{
					text: "אימייל",
					value: "user.email"
				},
				{
					text: "מסלול",
					value: "plan.description"
				},
				{
					text: "מחיר",
					value: "final_price"
				},
				{
					text: "השתמשו בקופון",
					value: "used_coupon"
				},
				{
					text: "שימושים במנוי",
					value: "final_usages"
				},
				{
					text: "תאריך",
					value: "purchased_at"
				}
			],
			lookingFor: null,
			showDialog: false
		};
	},
	computed: {
		subscriptions() {
			return this.$store.state.SubscriptionModule.subscriptions.map(
				subscription => {
					const plan = subscription.plan;
					const purchase = subscription.purchase;
					if (purchase) {
						subscription.used_coupon = "לא";
						subscription.final_price = purchase.sum;
						if (subscription.final_price < plan.price) {
							subscription.used_coupon = "כן";
						}
					} else {
						subscription.final_price = "חינם";
						if (parseInt(plan.price) === 0) {
							subscription.used_coupon = "לא";
						} else {
							subscription.used_coupon = "כן";
						}
					}
					subscription.final_usages =
						subscription.usages.length + " מתוך " + subscription.times;
					return subscription;
				}
			);
		}
	},
	async created() {
		this.loading = true;
		await this.$store.dispatch(
			subscriptionTypes.FETCH_PROJECT,
			this.$route.params.id
		);
		this.loading = false;
	},
	methods: {
		downloadExcel() {
			window.open("/api/admin/export/users/" + this.$route.params.id, "_blank");
		}
	}
};
</script>

<style scoped></style>
